<template>
	<div
			v-if="ready"

			:aria-label="accessibleLabel"
			:class="elementClass"
			:style="style"
			tabindex="0"
	>
		<component
				:is="blockComponent"
				ref="innerElement"
				:block="blockRef"
				:block-data="blockData"
				:blockId="blockKey"
				:is-visible="isVisible"
				:is-in-viewport="isInViewPort"
				:page="page"
				:seen="seen"
				:style="contentStyle"
		/>
		<template v-if="isXRayEnabled">
			<x-ray-click-regions
					:block-data="blockData"
					:block-rendered="renderedBlockData"
					:flyer-data="pages"
					:flyer-rendered="flyerRenderedData"
					:imageRendered="imageRenderedData"
					:page="page"
					:page-rendered="pageRenderedData"
					:pageData="page"
					:product-rendered="productRenderedData"/>
		</template>
		<div v-if="showDebug">
			<pre  class="debug">{{ debug }}</pre>
		</div>

	</div>
</template>

<script>

import {mapGetters, mapState} from "vuex";
import ProductElement from "@/components/block/elements/ProductElement.vue";
import ProductCarousel from "@/components/block/elements/ProductCarousel.vue";
import ProductCarouselV2 from "@/components/block/elements/ProductCarouselV2.vue";
import AdElement from "@/components/block/elements/AdElement.vue";
//import ProductBlockVideoElement from "@/components/block/elements/ProductBlockVideoElement.vue";
import XRayClickRegions from "@/features/x-ray/XRayClickRegions.vue";
import XRayModal from "@/features/x-ray/XRayModal.vue";
import Lytics from "@/classes/Lytics";
import ProductBlockVideoElement from "@/components/block/elements/ProductBlockVideoElement.vue";

export default {
	name: "FlyerBlock",
	props: {
		page: {
			type: Object,
			default: () => {
				return {};
			}
		},
		blockData: {
			type: Object
		},
		rootScrollContainer: {
			type: String || Object
		},
		blockKey: {
			type: String
		},
		scaleUnitWidth: {
			type: Number,
			default: null
		},
		scaleUnitHeight: {
			type: Number,
			default: null
		},
		contentFit: {
			type: String,
			default: null
		}
	},
	components: {XRayModal, XRayClickRegions},
	data() {
		return {
			isVisible: false,
			isPreLoaded: false,
			isInViewPort: false,
			ready: false,
			seen: false,
			classes: {
				'flyer-block': true
			},
			inBlockVisibleState: false,
			flyerBlockContainer: null,
			debug: ''
		}
	},
	mounted() {
		this.ready = true;
		//this.classes[this.blockComponent.name] = true;

		/*this.$nextTick(() => {
			const container = this.$el.closest('.flyer-block-container');
			if (container?.__vue__) {
				this.flyerBlockContainer = container.__vue__;
				this.flyerBlockContainer.registerBlock(this);
			}
		})*/

		/*const options = this.getObserverOptions(false);
		const observer = new IntersectionObserver(this.onViewPortChange, options);

		const target = this.$refs?.innerElement?.$el;
		observer.observe(target);*/

		/*    setTimeout(() => {
			  this.$nextTick(() => {
				const options = this.getObserverOptions(false);
				const observer = new IntersectionObserver(this.onViewPortChange, options);

				const target = this.$refs.innerElement.$el;
				observer.observe(target);
			  });
			}, 500);*/
	},

	methods: {
		getObserverOptions(marginIncluded) {
			const observerOptions = {
				root: document.getElementById(this.rootScrollContainer),
				rootMargin: marginIncluded ? "100%" : "0px",
			};
			return observerOptions;
		},

		// separate intersection observer callback because loading the block images happens before scrolling into viewport
		// vs. analytics impression happens when it is in viewport
		onViewPortChange(entries) {
			entries.forEach(entry => {
				this.isInViewPort = entry.isIntersecting;
			});
		},

		onVisibilityChange(isVisible) {
			//console.log('FlyerBlock onVisibilityChange: ', isVisible);
			this.isInViewPort = isVisible;
		},

		onPreloadVisibilityChange(isVisible) {
			//console.log('FlyerBlock onPreloadVisibilityChange: ', isVisible);
			this.isVisible = isVisible;
			if (isVisible && !this.seen) {
				this.seen = true;
			}
		},
		getProductActionType(product) {
			return (product?.actionType || product?.sku || '').toString().toLowerCase();
		},
		findProductBySkuOrAction(skuOrAction) {
			const products = this.blockData?.products || [];
			const needle = (skuOrAction || '').toString().toLowerCase();
			return products.find((p) => this.getProductActionType(p) === needle);
		}
	},
	computed: {
		...mapState(['pages', 'pageRenderedData', 'flyerRenderedData', 'productRenderedData', 'imageRenderedData', 'currentPageNumber']),
		...mapGetters('screen', ['displayMode', 'flyerOrientation']),
		...mapGetters('config', ['features', 'branding']),
    ...mapGetters('ctUser', ['triangleOffers']),
		...mapGetters(['isXRayEnabled', 'content']),
		...mapGetters('search', {'searchConfig': 'config'}),
		showDebug() {
			return this.$route.query.debug === 'true';
		},
		unitWidth() {
			return this.page.unitWidth;
		},
		unitHeight() {
			return this.page.unitHeight;
		},
		rowScale() {
			return this.scaleUnitHeight? this.page.unitHeight / this.scaleUnitHeight : 1;
		},
		colScale() {
			return this.scaleUnitWidth? this.page.unitWidth / this.scaleUnitWidth : 1;
		},
		rowSpan() {
			if(this.scaleUnitHeight) {
				const h = this.page.unitHeight * this.blockData.rowSpan;
				return Math.ceil(h / this.scaleUnitHeight);
			}
			return this.blockData.rowSpan;
		},
		colSpan() {
			if(this.scaleUnitWidth) {
				const w = this.page.unitWidth * this.blockData.colSpan;
				return Math.ceil(w / this.scaleUnitWidth);
			}

			return this.blockData.colSpan;
		},
		width() {
			return this.unitWidth * this.colSpan;
		},
		height() {
			return this.unitHeight * this.rowSpan;
		},
		isCarousel() {
			return (this.blockData?.carouselBlocks?.length ?? 0) >= 1;
		},
		isAdPage() {
			return this.page.isAdPage;
		},
		isSearchResult() {
			return this.page.name === "search_results";
		},
		hasInBlockVideo() {
			const products = this.blockData?.products || [];
			return products.some((p) => this.getProductActionType(p).includes('inblock'));
		},
		elementClass() {
			return Object.assign({}, this.classes, {[this.blockComponent.name]: true});
		},
		//the bellow function added for fixing accessibility issue in OfferListItem
		//as it is driven from flyerblock but the data coming from different api ,
		// so we need to get this.blockData?.componentData data
		componentDataLabel() {
			const data = this.blockData?.componentData;
			if (!data?.desc) return null;

			const parts = [data.desc];
			if (data.savings) parts.push(`${this.content?.offers?.save || ''} ${data.savings}%`);
			if (data.promoPrice) parts.push(`${this.content?.offers?.sale || ''} ${data.promoPrice}`);
			if (data.retailPrice) parts.push(`${this.content?.offers?.reg || ''} ${data.retailPrice}`);
			return parts.join('. ');
		},
		accessibleLabel() {
			const productContents = this.blockData?.products?.find(product => product.contents)?.contents;
			return productContents || this.componentDataLabel || this.blockData?.altText || this.page?.name || null;
		},
		blockComponent() {
			if (this.blockData?.type === 'component') return this.blockData.component;
			if (this.isCarousel && this.features?.carousels?.template === 'v2') return ProductCarouselV2;
			if (this.isCarousel) return ProductCarousel;
			if (this.isAdPage) return AdElement;
			if (this.hasInBlockVideo) return ProductBlockVideoElement;
			return ProductElement;
		},
		placement() {
			let pm = this.blockData.placement[this.displayMode];
			if (this.displayMode === 'desktop' && this.flyerOrientation === 'vertical') {
				pm = this.blockData.placement['tablet'];
			}
			return pm;
		},
		hasPlacement() {
			return this.placement?.visible;
		},
		coordinateStyle() {
			const coord = this.placement?.coordinates;
			const top = coord[0] + 1; //0
			const left = coord[1] + 1; //0
			const bottom = coord[2] + 1; //7
			const right = coord[3] + 1; //19
			const order = this.placement?.order || 'initial';
			console.log('Coords:', coord, `   left: ${left}  top: ${top} right: ${right}  bottom: ${bottom}`);
			const style = {
				gridColumn: `${left} / ${right}`,
				gridRow: `${top} / ${bottom}`,
				order: order,
				display: 'grid',
				position: 'relative'
			}
			console.log('Coords Style: ', style)
			return style;
		},
		style() {
			if (this.isSearchResult && this.placement?.coordinates && this.searchConfig?.layout?.useCoords) {
				return this.coordinateStyle;
			}

			const order = this.placement?.order || 'initial';
			let s = {
				gridColumn: `span ${this.colSpan}`,
				gridRow: `span ${this.rowSpan}`,
				order: order,
				display: 'grid',
				position: 'relative'// `${this.canShowAd ? "block" : "none"}`,,
			};

			if (this.isSearchResult) {
				delete s.order;
			}

			if (this.isAdPage) {
				const adMode = this?.branding?.ads?.orientation?.[this.flyerOrientation];
				if (adMode?.alignment === 'auto') {
					s.height = `inherit`;
					if (adMode?.offset) {
						s.height = `calc(100% + ${adMode?.offset})`;
					}
				}
			}

			return s;
		},
		contentStyle() {
			if(!this.contentFit)return {};

			const containerW = (this.scaleUnitWidth || this.unitWidth) * this.colSpan;
			const containerH = (this.scaleUnitHeight || this.unitHeight) * this.rowSpan;
			// eslint-disable-next-line no-unused-vars
			const containerA = containerW / containerH;


			const w = this.blockData?.images[0]?.width || this.page.unitWidth * this.blockData.colSpan;
			const h = this.blockData?.images[0]?.height || this.page.unitHeight * this.blockData.rowSpan;
			// eslint-disable-next-line no-unused-vars
			const a = w / h;
			const s = {
				aspectRatio: `${w} / ${h}`
			}

			//const ch = containerW / a;

			const compare = this.contentFit === 'contain'? containerA < a :  containerA > a ;// ch < containerH : ch > containerH;


			//const coords = this.placement?.coordinates

			// eslint-disable-next-line vue/no-side-effects-in-computed-properties
			this.debug = `Scale [${this.contentFit}]: ${compare? 'Width':'Height'} \nContainer:\n cw: ${containerW} \n ch: ${containerH} \n ca: ${containerA} \nChild: \n w: ${w} \n h: ${h} \n a: ${a}`;

			if(compare){
				s['left'] = 0;
				s['right'] = 0;
				s['top'] = '50%';
				s['transform'] = 'translate(0, -50%)';
			} else {
				s['top'] = 0;
				s['bottom'] = 0;
				s['left'] = '50%';
				s['transform'] = 'translate(-50%, 0)';
			}
			return s
		},

		blockRef() {
			return this;
		},
		renderedBlockData() {
			return {
				unitWidth: this.unitWidth,
				unitHeight: this.unitHeight,
				rowSpan: this.rowSpan,
				colSpan: this.colSpan,
				width: this.width,
				height: this.height,
				placement: this.placement,
				style: this.style
			};
		}
	},
	watch: {
		isInViewPort(val) {
			if (val) {
				const playProduct = this.findProductBySkuOrAction('Play');
				const videoUrl = playProduct?.url || playProduct?.contentSource;
				const inblockUrl = this.findProductBySkuOrAction('Inblock')?.url;
				const linkUrl = this.blockData.linkUrl;

				let item_list_name = 'flyer';
				if (videoUrl) {
					item_list_name = 'video impression';
					Lytics.TriggerVideoImpression({
						url: videoUrl,
            video_title: Lytics.videoTitleFromUrl(videoUrl),
						page_number: this.page.page_num || this.currentPageNumber
					});
				}
				if (this.isCarousel) {
					item_list_name = 'carousel impression';
				}
				if (linkUrl) {
					Lytics.TriggerLinkImpression({
						url: linkUrl,
						page_number: this.page.page_num || this.currentPageNumber,
					})
				}
				if (this.hasInBlockVideo) {
					item_list_name = 'in_block_video_impression';
					Lytics.TriggerInBlockVideoImpression({
						url: inblockUrl,
						page_number: this.page.page_num || this.currentPageNumber
					});
				}

				const products = this.blockData.products.filter(p => p.sku !== 'Play' && p.sku !== 'url');

				Lytics.addToEventQueue({
					item_list_name,
					page_number: this.page.page_num || this.currentPageNumber,
          personalized_offers: this.triangleOffers || [],
					items: products.map((p, i) => {
						return {
							product_id: p.sku,
							name: p.productEn || p.productFr,
							name_en: p.productEn,
							name_fr: p.productFr,
							price: p.regularPrice,
							position: i,
							sale_price: p.salePrice,
							category: p.mainCategoryEn || p.mainCategoryFr,
							category_2: p.subCategoryEn || p.subCategoryFr,
							image_url: p.productImage,
							quantity: 1,
						}
					})
				})

				if (this.isAdPage) {
					Lytics.TriggerAdImpression({
						name: this.page.name,
						url: this.blockData.linkUrl,
						image_url: this.blockData.images[0]?.image,
						size: `${this.page.pageWidth}x${this.page.pageHeight}`
					})
				}
			}
		}
	}
}
</script>
<style lang="scss">
	.debug {
	  font-size: 8px;
	  background: #000;
	  color: yellow;
	}
</style>
